import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { SubscriptionModel } from './subscriptions.model';
import { LoaderEnabled } from '../../../core/services/loader.service';
import { KkmsDetailsService } from '../../../core/services/kkm-details.service';
import { BpService } from '../../../core/services/bp.service';
import { SubscriptionsApiService } from '../../../core/modules/subscriptions/subscriptions-api.service';
import { SubscriptionFilter } from '../../../core/modules/subscriptions/subscriptions.types';
import { IBp } from '../../../core/modules/business-process/business-process.types';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionsService {
  constructor(
    private bpService: BpService,
    private subscriptionsApiService: SubscriptionsApiService,
    private kkmsDetailsService: KkmsDetailsService,
  ) {}

  @LoaderEnabled()
  getSubscriptions(subscriptionFilter: SubscriptionFilter = {}): Observable<SubscriptionModel> {
    return this.subscriptionsApiService.fetchSubscriptions(subscriptionFilter)
      .pipe(
        map(subscriptionModel => ({
          ...subscriptionModel,
          subscriptions: subscriptionModel.subscriptions?.map(subscription => ({
            ...subscription,
            ...this.kkmsDetailsService.getAvailableActions(subscription.regStatus, subscription.billingStatus),
          })),
        })),
      );
  }

  kkmToggleRenewal(kkmId: number, billingIsAutoRenewableSubscription: boolean): Observable<IBp> {
    return this.bpService.start('kkmToggleRenewalProcess', {
      kkmId,
      billingIsAutoRenewableSubscription,
    }, {
      skipLocationChange: true,
    });
  }
}
